import React from 'react';
import PropTypes from 'prop-types';

/**
 * EmptyState component for web
 *
 * Displays when lists or views have no content (no documents, no grievances, etc.)
 */
const EmptyState = ({
  icon,
  title,
  description,
  action,
  className = '',
  ...props
}) => {
  const defaultIcon = (
    <svg
      className="empty-state-icon"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
      />
    </svg>
  );

  return (
    <div className={['empty-state', className].filter(Boolean).join(' ')} {...props}>
      {icon !== undefined ? icon : defaultIcon}

      {title && (
        <h3 className="empty-state-title">
          {title}
        </h3>
      )}

      {description && (
        <p className="empty-state-description">
          {description}
        </p>
      )}

      {action && (
        <div className="flex gap-3">
          {action}
        </div>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
  className: PropTypes.string,
};

export default EmptyState;
